import { render, staticRenderFns } from "./ConstructionInstallationCostBudget.vue?vue&type=template&id=0b1fc602&scoped=true"
import script from "./ConstructionInstallationCostBudget.vue?vue&type=script&lang=js"
export * from "./ConstructionInstallationCostBudget.vue?vue&type=script&lang=js"
import style0 from "./ConstructionInstallationCostBudget.vue?vue&type=style&index=0&id=0b1fc602&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1fc602",
  null
  
)

export default component.exports